<script>
import includes from 'lodash/includes'
import isEmpty from 'lodash/isEmpty'
import trim from 'lodash/trim'
import isArray from 'lodash/isArray'
import isString from 'lodash/isString'
import isNumber from 'lodash/isNumber'
import isNull from 'lodash/isNull'
import get from 'lodash/get'

import EventBus from './../EventBus.js'

export default {
  name: 'field',
  props: {
    name: {
      type: String,
      required: false,
      default: '',
    },
    participant_index: {
      type: Number,
      required: false,
      default: -1,
    },
    participant_index_pet: {
      type: Number,
      required: false,
      default: -1,
    },
    campaign_id: {
      type: String,
      required: false,
      default: '',
    },
    rules: {
      type: Array,
      required: false,
      default: () => [],
    },
    is_email: {
      type: Boolean,
      required: false,
      default: false,
    },
    is_agreement: {
      type: Boolean,
      required: false,
      default: false,
    },
    is_birthday: {
      type: Boolean,
      required: false,
      default: false,
    },
    is_gender: {
      type: Boolean,
      required: false,
      default: false,
    },
    is_group_contact: {
      type: Boolean,
      required: false,
      default: false,
    },
    multiple_options: {
      type: Boolean,
      required: false,
      default: false,
    },
    scope: {
      type: String,
      required: false,
      default: '',
    },
    match_value: {
      type: Object,
      required: false,
      default: () => {
        return {
          value: '',
          timestamp: '',
        }
      },
    },
    debug_value: {
      type: [Number, String, Array],
      required: false,
      default: '',
    },
     lang: {
      type: String,
      default: 'en',
    },
  },
  data() {
    return {
      inputValue: '',
      inputValueArr: [],
      error: false,
      inputIcon: '',
      status: '',
      other: '',
    }
  },
  mounted() {
    this.$emit('input-mounted')
    if (this.debugAutoFill) {
        if (this.multiple_options) {
          this.inputValueArr = isEmpty(this.debug_value) ? [] : this.debug_value
        } else {
          this.inputValue = this.debug_value
        }
    }
  },
  computed: {
    participants() {
      return get(this, '$parent.participants')
    },
    participant() {
      return get(this, `$parent.participants[${this.participant_index}]`, {})
    },
    globalVars() {
      return get(this, '$root.globalVars', {})
    },
    errorMsg() {
      return get(this, '$root.globalVars.errorMsg', {})
    },
    debugMode() {
      return get(this, '$root.globalVars.debugMode', false)
    },
    debugAutoFill() {
      return get(this, '$root.globalVars.debugAutoFill', false)
    },
    avaliableYear() {
      return get(this, '$parent.avaliableYear', [])
    },
    birthMonthRange() {
      return get(this, '$parent.birthMonthRange', [])
    },
    birthDayRange() {
      return get(this, '$parent.birthDayRange', [])
    },
    isParticipantField() {
      return (this.participant_index !== -1)
    },
    isParticipantPetFieldPet() {
    console.log(this.participant_index_pet );
      return (this.participant_index_pet !== -1)
    },
    isCampaignField() {
      return !isEmpty(this.campaign_id)
    },
    hasError() {
      return this.status === 'error'
    },
    hasSucc() {
      return this.status === 'succ'
    },
    getInputValue() {
      return this.multiple_options ? this.inputValueArr : this.inputValue
    },
    withOther() {
      return isArray(this.getInputValue) && includes(this.getInputValue, 'other') ? true : false
    },

  },
  methods: {
  checkRecepit(){
	//alert("a");
	//console.log();
	this.$parent.rec();
},


  checkRecepit1(){
	//alert("a");
	//console.log(this);
	//let v = this.$children[0].inputValue;//this.getInputValue.toString();
	//alert(v);
	this.$parent.rec1(1);
},
 checkRecepit2(){
	//alert("a");
	//console.log(this);
	//let v = this.$children[0].inputValue;//this.getInputValue.toString();
	//alert(v);
	this.$parent.rec1(2);
},

    validateField() {
      return new Promise((resolve) => {
        this.errorHandler().then(() => {
          resolve()
        })
      })
    },
    numberOnly: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    errorHandler() {
      let validations = []
      this.error = false
      if (includes(this.rules, 'required')) validations.push(this.requiredFieldHandler())
      if (includes(this.rules, 'hkid')) validations.push(this.hkidFieldHandler())
      if (includes(this.rules, 'phone')) validations.push(this.phoneFieldHandler())
      if (includes(this.rules, 'emergencyPhone')) validations.push(this.emergencyPhoneFieldHandler())
      if (includes(this.rules, 'email')) validations.push(this.emailFieldHandler())
      if (includes(this.rules, 'match')) validations.push(this.matchFieldHandler())
      if (includes(this.rules, 'confirmEmail')) validations.push(this.confirmEmailFieldHandler())
      if (includes(this.rules, 'donationRequired')) validations.push(this.donationRequiredFieldHandler())
      if (includes(this.rules, 'donationEmail')) validations.push(this.donationEmailFieldHandler())
      if (includes(this.rules, 'receiptNameRequired')) validations.push(this.receiptNameRequiredFieldHandler())
      if (includes(this.rules, 'donationEmail1')) validations.push(this.donationEmail1FieldHandler())
      if (includes(this.rules, 'receiptTypeRequired')) validations.push(this.receiptTypeRequired())
      return Promise.all(validations).then(() => {
        this.status = (this.error) ? 'error' : 'succ'
      })
    },
    requiredFieldHandler() {
      return new Promise((resolve) => {
        if (this.error) {
          resolve()
          return
        }
        let valid = false
        if (!isNull(this.getInputValue)) {
          if (isString(this.getInputValue)) {
            valid = !isEmpty(this.getInputValue.toString())
          }
          if (isArray(this.getInputValue)) {
            valid = this.getInputValue.length > 0
          }  
          if (isNumber(this.getInputValue)) {
            valid = !isEmpty(this.getInputValue.toString())
          }
        } 
        if (this.withOther) valid = !isEmpty(this.other.toString())
        this.error = !valid ? (this.is_agreement ? get(this, 'errorMsg.agreement.msg', '') : get(this, 'errorMsg.required.msg', '')) : false
        this.inputIcon = !valid ? 'clear' : 'done'
        if (this.error && this.debugMode) console.log(this.name, ' error requiredFieldHandler')
        resolve()
      })
    },
    receiptTypeRequired() {
        return new Promise((resolve) => {
            if (this.error) {
                resolve()
                return
            }
            let valid = false
            if (!isNull(this.getInputValue)) {
                if (isString(this.getInputValue)) {
                    valid = !isEmpty(this.getInputValue.toString())
                }
                if (isArray(this.getInputValue)) {
                    valid = this.getInputValue.length > 0
                }
                if (isNumber(this.getInputValue)) {
                    valid = !isEmpty(this.getInputValue.toString())
                }
            }
            if (this.withOther) valid = !isEmpty(this.other.toString())
            const defaultMsg = get(this, `errorMsg.receiptTypeRequired.en`, '')
            this.error = !valid ? get(this, `errorMsg.receiptTypeRequired[${this.lang}]`, defaultMsg) : false
            this.inputIcon = !valid ? 'clear' : 'done'
            if (this.error && this.debugMode) console.log(this.name, ' error requiredFieldHandler')
            resolve()
        })
    },
    donationRequiredFieldHandler() {
      return new Promise((resolve) => {
        if (this.error) {
          resolve()
          return
        }
        let valid = false
        if (!isNaN(Number(this.getInputValue))) {
        console.log(Number(this.getInputValue) <= 1000000 ? 'is valid' : 'not valid');
            valid = !isEmpty(this.getInputValue.toString()) && Number(this.getInputValue) >= 30 && Number(this.getInputValue) <= 1000000
        }

        if (!valid) {
            if (isEmpty(this.getInputValue)) {
                const defaultMsg = get(this, `errorMsg.donationAmountRequired.en`, '')
                this.error = get(this, `errorMsg.donationAmountRequired[${this.lang}]`, defaultMsg)
            } else if (isNaN(Number(this.getInputValue))) {
                const defaultMsg = get(this, `errorMsg.donationAmountNumberOnly.en`, '')
                this.error = get(this, `errorMsg.donationAmountNumberOnly[${this.lang}]`, defaultMsg)
            } else if (!isNaN(Number(this.getInputValue)) && Number(this.getInputValue) < 30) {
                const defaultMsg = get(this, `errorMsg.donationAmountLessThan30.en`, '')
                this.error = get(this, `errorMsg.donationAmountLessThan30[${this.lang}]`, defaultMsg)
            } else if (!isNaN(Number(this.getInputValue)) && Number(this.getInputValue) > 1000000) {
                const defaultMsg = get(this, `errorMsg.donationAmountGreaterThan1000000.en`, '')
                this.error = get(this, `errorMsg.donationAmountGreaterThan1000000[${this.lang}]`, defaultMsg)
            }
        }
        this.inputIcon = !valid ? 'clear' : 'done'
        if (this.error && this.debugMode) console.log(this.name, ' error amount requiredFieldHandler')
        resolve()
      })
    },
    receiptNameRequiredFieldHandler() {
      return new Promise((resolve) => {
        if (this.error) {
          resolve()
          return
        }
        let valid = false
        if (this.$parent.expendrec() == 1 ) 
	{
            valid = !isEmpty(this.getInputValue.toString())
        }
	else
		valid = true;
	    const defaultMsg = get(this, `errorMsg.receiptName.en`, '')
        this.error = !valid ? get(this, `errorMsg.receiptName[${this.lang}]`, defaultMsg) : false
	/*
        if (!valid) {
            if (isEmpty(this.getInputValue)) {
                this.error = get(this, 'errorMsg.donationAmountRequired.msg', '')
            } else if (isNaN(Number(this.getInputValue))) {
                this.error = get(this, 'errorMsg.donationAmountNumberOnly.msg', '')
            } else if (!isNaN(Number(this.getInputValue)) && Number(this.getInputValue) < 30) {
                this.error = get(this, 'errorMsg.donationAmountLessThan30.msg', '')
            } else if (!isNaN(Number(this.getInputValue)) && Number(this.getInputValue) > 1000000) {
                this.error = get(this, 'errorMsg.donationAmountGreaterThan1000000.msg', '')
            }
        }
	*/
        this.inputIcon = !valid ? 'clear' : 'done'
        if (this.error && this.debugMode) console.log(this.name, ' error amount requiredFieldHandler')
        resolve()
      })
    },
    donationEmail1FieldHandler() {
      return new Promise((resolve) => {
        if (this.error) {
          resolve()
          return
        }
        let valid = false
        if (this.$parent.expendrec() == 1 ) 
	{
		valid = !isEmpty(this.getInputValue.toString())
		if ( this.$parent.getRType() == 1 && valid )
		{
		console.log(this.getInputValue.toString());
			valid = this.getInputValue.toString().match(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/);
		}
        }
	else
	{	
		valid = true;
	}
	console.log("rts="+this.$parent.expendrec());
	console.log("rt="+this.$parent.getRType());

    const defaultMsg = get(this, `errorMsg.donationEmail1.en`, '')
    this.error = !valid ? get(this, `errorMsg.donationEmail1[${this.lang}]`, defaultMsg) : false
	/*
        if (!valid) {
            if (isEmpty(this.getInputValue)) {
                this.error = get(this, 'errorMsg.donationAmountRequired.msg', '')
            } else if (isNaN(Number(this.getInputValue))) {
                this.error = get(this, 'errorMsg.donationAmountNumberOnly.msg', '')
            } else if (!isNaN(Number(this.getInputValue)) && Number(this.getInputValue) < 30) {
                this.error = get(this, 'errorMsg.donationAmountLessThan30.msg', '')
            } else if (!isNaN(Number(this.getInputValue)) && Number(this.getInputValue) > 1000000) {
                this.error = get(this, 'errorMsg.donationAmountGreaterThan1000000.msg', '')
            }
        }
	*/
        this.inputIcon = !valid ? 'clear' : 'done'
        if (this.error && this.debugMode) console.log(this.name, ' error amount requiredFieldHandler')
        resolve()
      })
    },
    hkidFieldHandler() {
      return new Promise((resolve) => {
        if (this.error) {
          resolve()
          return
        }
        const valid = trim(this.getInputValue.toString()).match(/^\d{4}$/)
        this.error = !valid ? get(this, 'errorMsg.hkid.msg', '') : false
        this.inputIcon = !valid ? 'clear' : 'done'
        if (this.error && this.debugMode) console.log(this.name, ' error hkid')
        resolve()
      })
    },
    phoneFieldHandler() {
      return new Promise((resolve) => {
        if (this.error) {
          resolve()
          return
        }
        const valid = trim(this.getInputValue.toString()).match(/^[456789]\d{7}$/)
        this.error = !valid ? get(this, 'errorMsg.phone.msg', '') : false
        this.inputIcon = !valid ? 'clear' : 'done'
        if (this.error && this.debugMode) console.log(this.name, ' error phone')
        resolve()
      })
    },
    emergencyPhoneFieldHandler() {
      return new Promise((resolve) => {
        if (this.error) {
          resolve()
          return
        }
        const valid = trim(this.getInputValue.toString()).match(/^[23456789]\d{7}$/)
        this.error = !valid ? get(this, 'errorMsg.emergencyPhone.msg', '') : false
        this.inputIcon = !valid ? 'clear' : 'done'
        if (this.error && this.debugMode) console.log(this.name, ' error em phone')
        resolve()
      })
    },
    emailFieldHandler() {
      return new Promise((resolve) => {
        if (this.error) {
          resolve()
          return
        }
        const valid = trim(this.getInputValue.toString()).match(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/)
        this.error = !valid ? get(this, 'errorMsg.email.msg', '') : false
        this.inputIcon = !valid ? 'clear' : 'done'
        if (this.error && this.debugMode) console.log(this.name, ' error email')
        resolve()
      })
    },
    donationEmailFieldHandler() {
      return new Promise((resolve) => {
        if (this.error) {
          resolve()
          return
        }
        const valid = trim(this.getInputValue.toString()).match(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/)
        if (!valid) {
            if (isEmpty(this.getInputValue)) {
                const defaultMsg = get(this, `errorMsg.donationEmailMissing.en`, '')
                this.error = get(this, `errorMsg.donationEmailMissing[${this.lang}]`, defaultMsg)
            } else {
                const defaultMsg = get(this, `errorMsg.donationEmailFormat.en`, '')
                this.error = get(this, `errorMsg.donationEmailFormat[${this.lang}]`, defaultMsg)
            }
        }
        this.inputIcon = !valid ? 'clear' : 'done'
        if (this.error && this.debugMode) console.log(this.name, ' error email')
        resolve()
      })
    },
    matchFieldHandler() {
      return new Promise((resolve) => {
        if (this.error) {
          resolve()
          return
        }
        const valid = this.getInputValue === get(this, 'match_value.value')
        this.error = !valid ? get(this, 'errorMsg.confirmEmail.msg', '') : false
        this.inputIcon = !valid ? 'clear' : 'done'
        if (this.error && this.debugMode) console.log(this.name, ' error match')
        resolve()
      })
    },
    confirmEmailFieldHandler() {
      return new Promise((resolve) => {
        if (this.error) {
          resolve()
          return
        }
        const valid = this.getInputValue === get(this, 'participant.fields.email', '')
        this.error = !valid ? get(this, 'errorMsg.confirmEmail.msg', '') : false
        this.inputIcon = !valid ? 'clear' : 'done'
        if (this.error && this.debugMode) console.log(get(this, 'participant.fields.email', ''), this.name, ' error confirm email')
        resolve()
      })
    },
  },
  watch: {
    getInputValue(value) {
      if (this.isParticipantPetFieldPet) {
      console.log("pET FIELD");
        EventBus.$emit('update-participant-field-pet', this.participant_index, this.name, value)
	}
      else if (this.isParticipantField) {
        EventBus.$emit('update-participant-field', this.participant_index, this.name, value)
      
      } else if (this.isCampaignField) {
        EventBus.$emit('update-campaign-field', this.campaign_id, this.name, value)
        this.$emit('update-campaign-participant', value)
      } else {
        EventBus.$emit('update-basic-field', this.name, value)
      }
    },
  }
}
</script>
